import React from "react";

interface Props {
  big?: boolean;
  pathFill?: string;
}
export default function Icon(props: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.big ? "74" : "48"}
      height={props.big ? "74" : "48"}
      viewBox="0 0 48 48"
      fill="none"
    >
      <path
        d="M42.25 36.625H10V7.375C10 7.16875 9.83125 7 9.625 7H7C6.79375 7 6.625 7.16875 6.625 7.375V39.625C6.625 39.8312 6.79375 40 7 40H42.25C42.4562 40 42.625 39.8312 42.625 39.625V37C42.625 36.7938 42.4562 36.625 42.25 36.625ZM20.125 27.5L25.5 32L33.5 25.7406C33.6018 25.7406 34.9129 27.6208 36.2145 29.5C37.5497 31.4277 38.875 33.3544 38.875 33.25V12.8125C38.875 12.475 38.4672 12.3109 38.2328 12.5453L28.375 22.4031L22.4969 16.5906C22.4264 16.5208 22.3312 16.4817 22.232 16.4817C22.1328 16.4817 22.0377 16.5208 21.9672 16.5906L13.1078 25.4781C13.0734 25.5126 13.0462 25.5535 13.0277 25.5986C13.0092 25.6436 12.9998 25.6919 13 25.7406V33.25C20.125 27.5 19.9187 27.5 20.125 27.5Z"
        fill="#262C34"
      />
    </svg>
  );
}
